import {FTUETrainerTextProps} from '@skillz/ui';
import {_m} from 'INTL';
import GameOperationsTrainerBase from './GameOperationsTrainerBase';
import {BUBBLE_ANIMATION} from './GameOperationsTrainerBase.config';
import {Animated} from 'react-native';
import SKZConstants from 'SKZConstants';

export default class GameOperationsTrainerStepBanner
  extends GameOperationsTrainerBase
  implements FTUETrainerTextProps
{
  bubbleAnimation?: Animated.TimingAnimationConfig | undefined;

  constructor() {
    super(SKZConstants.ETrainerAssetKey.FaceLeft);
    this.text = _m(
      'Check out our latest special offers and events! Tap the banners later to learn more'
    );
    this.overlayVisible = false;
    this.bubbleAnimation = BUBBLE_ANIMATION;
  }
}
